<template>
  <v-layout row justify-center>
    <v-dialog class="z-index-max" v-model="seatDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <!--  header -->
        <v-toolbar class="elevation-0" >
          <v-btn icon  @click="onCancel">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title class="primary--text">{{$t('enrollment.steps.seats_selection.component.title')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- loader -->
        <v-progress-linear
        v-if="seatChartLoader"
        :active="seatChartLoader"
        class="ma-0"
        height="5"
        :indeterminate="true"
        ></v-progress-linear>
        <div class="pa-3">
            <v-layout row wrap>
                <v-flex xs12 md9  :class="$vuetify.breakpoint.width > 959 ? !$vuetify.rtl ? 'pr-2' : 'pl-2' : ''">
                    <!-- Display seats status & categories -->
                    <SeatsClassifier class="mb-4"></SeatsClassifier>
                    <!-- Theater Screen Effect -->
                    <div class="theater-screen ma-auto py-2">
                        <div class="screen-label subheading secondary--text">{{$t('screener.screen.label')}}</div>
                    </div>
                    <!-- Seat chart -->
                    <v-card class="border-grey-all mb-2" flat height="70vmin" style="overflow:auto;">
                        <SeatsChart
                        class="pa-2"
                        :config="chartConfig"
                        :seats="seats"
                        :reservedSeats="reservedSeats"
                        :seatsStatus="seatsStatus"
                        :selectedSeats="selectedSeats"
                        :seatPricing="seatPricing"
                        :lockedSeatsByUser="lockedSeatsByUser"
                        @onSeatSelected="onSeatSelected"
                        ></SeatsChart>
                    </v-card>

                </v-flex>
                <!-- Seats cart -->
                <v-flex xs12 md3 :class="$vuetify.breakpoint.width > 959 ? !$vuetify.rtl ? 'pl-2' : 'pr-2' : ''">
                    <SeatsCart
                    :title="$t('screener.seats.cart.title')"
                    :headers="cartHeaders"
                    :actions="cartActions"
                    :instructions="cartInstructions"
                    :seats="selectedSeats"
                    :discounts="ticketDiscounts"
                    :currency="company.currency"
                    :loading="bookingLoader"
                    :maxSeatsToBeSelected="maxSeatsToBeSelected"
                    :screener_id="screener?screener.id:null"
                    ></SeatsCart>
                </v-flex>
            </v-layout>
        </div>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {EventBus} from '@/event-bus.js';
import {seatMethods} from "@/mixins/seats"
import SeatSVG from "@/components/SeatSVG"
import SeatsClassifier from "@/components/screener/physicalEvent/SeatsClassifier"
import SeatsCart from "@/components/screener/physicalEvent/SeatsCart"
import SeatsChart from "@/components/screener/physicalEvent/SeatsChart"
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name:"EnrollmentSeatSelection",
    props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        },
        screener:{
            type: Object,
            default: null
        }
    },
    components:{
        SeatSVG,
        SeatsClassifier,
        SeatsCart,
        SeatsChart
    },
    data () {
      return {
        seatDialog: false,
        seats: {},
        selectedSeats: [],
        reservedSeats:[],
        seatsStatus:{},
        seatPricing:{},
        chartConfig:{
            rows: null,
            cols: null,
        },
        cartHeaders: [
            {
                text: this.$t("screener.seats.category.title"),
                align: 'center',
                sortable: false,
                value: 'category'
            },
            {
                text: this.$t("screener.seats.discounts.title"),
                align: 'center',
                sortable: false,
                value: 'ticket_type'
            },
            {
                text: this.$t("screener.seats.label.title"),
                align: 'center',
                sortable: false,
                value: 'label'
            },
            {
                text: this.$t("screener.seats.price.title"),
                align: 'center',
                sortable: false,
                value: 'price'
            },
        ],
        cartActions: [
        //   {
        //     title: 'Reset',
        //     color:'grey',
        //     icon:"mdi-refresh",
        //     handler:this._resetSelectedSeats
        //   },
          {
            title: this.$t("screener.seats.action.lock.title"),
            color:'primary',
            icon:'mdi-checkbox-marked-circle',
            handler:this.lockSeats
          },
        ],
        bookingLoader:false,
        seatChartLoader:false,
        lockedSeatsByUser:[],
        ticketDiscounts:{},
        maxSeatsToBeSelected:0
      }
    },
    computed:{
        ...mapState({
            company: (state) => state.company.company,
        }),
        ...mapFields("consumer", {
            consumer_uuid: "uuid",
        }),
        cartInstructions(){
            return [
                {
                    text:this.$t("screener.seats.cart.instructions.1",{max_seats:this.maxSeatsToBeSelected}),
                },
                {
                    text:this.$t("screener.seats.cart.instructions.2"),
                },
                {
                    text:this.$t("screener.seats.cart.instructions.3"),
                }
            ]
        }
    },
    watch:{
        screener:{
            deep:true,
            handler:function(){
                if(!this.screener){
                    return;
                }
                this.setRowCols();
                this.setSeats();
                this.setReservedSeats();
                this.setSeatPricing();
                this.setTicketDiscounts();
                this.setMaxSeatsToBeSelectedCount();
            }
        },
        seatDialog: function (newValue, oldValue) {
            if (newValue) {
                this.getSeatsStatus();
                this.getLockedBooking();
            }
        }
    },
    created(){
        let _this = this;
        EventBus.$on("showSeatChart",function(){
            _this.showSeatChart();
        })
    },
    mixins:[seatMethods],
    methods:{
        showSeatChart(){
            this.seatDialog = true;
        },
        hideSeatChart(){
            this.seatDialog = false;
        },
        setRowCols(){
            if(!this.screener.physical_venue){
                return;
            }
            this.chartConfig.rows = this.screener.physical_venue.rows;
            this.chartConfig.cols = this.screener.physical_venue.columns;
        },
        setSeats() {
            if(!this.screener.physical_venue){
                return;
            }
            this.seats = this.screener.physical_venue.seats
        },
        setReservedSeats(){
            if(!this.screener.physical_venue){
                return;
            }
            this.reservedSeats = this.screener.physical_venue.not_for_sale
        },
        setSeatPricing(){
            this.seatPricing = this.screener.physical_venue_seats_pricing;
        },
        setTicketDiscounts(){
            if(!this.screener.physical_venue_ticket_types_discount){
                return;
            }
            this.ticketDiscounts = this.screener.physical_venue_ticket_types_discount
        },
        setMaxSeatsToBeSelectedCount(){
             if(!this.screener.physical_venue_max_seats_purchase_count){
                return;
            }
            this.maxSeatsToBeSelected = this.screener.physical_venue_max_seats_purchase_count;
        },
        reset(){
            this._resetSelectedSeats();
            this.hideSeatChart();
        },
        _resetSelectedSeats(){
            this.selectedSeats = [];
        },
        _removeSeatFromSelected(seatId){
            this.selectedSeats = this.selectedSeats.filter((seat) => seat.id !== seatId);
            return this.selectedSeats;
        },
        _addSeatToSelected(seatId,ticketType){
            if(this._isSeatSelected(seatId)){
                return;
            }
            let seat = this.getSeat(seatId);
            seat.ticket_type = ticketType;
            this.selectedSeats.push(Object.assign({},seat));
        },
        onSeatSelected(seatId) {
            // Check if waiting for response
            if(this.bookingLoader || this.seatChartLoader){
                return;
            }
            if(this._isSeatSelected(seatId)) {
                this._removeSeatFromSelected(seatId);
                return;
            }
            // User can selected upto defined max seats only
            if(this.selectedSeats.length==this.maxSeatsToBeSelected){
                this.$store.dispatch("app/showMessage",{
                    message: this.$t('screener.seats.cart.max_seat_selected.title'),
                    color:"warning"
                });
                return;
            }
            this._addSeatToSelected(seatId,this.DEFINES.DEFAULT_SEAT_TICKET_TYPE);
        },
        async getSeatsStatus(){
            this.seatChartLoader = true;
            try {
                let response =  await this.$store.dispatch("screening/getSeatsStatus",{
                    screener_id:this.screener.id
                })
                this.seatsStatus = response.seats_status;
            } catch (error) {
                this.$store.dispatch("app/showMessage",{
                    message: error.message,
                    color: "error"
                })
            } finally{
                this.seatChartLoader = false;
            }
        },
        _lockSeatsPayload(){
            let ticket_types_discount={};
            this.selectedSeats.forEach (function (seat) {
                ticket_types_discount[seat.id] = seat.ticket_type;
            });
            return {
                screener_id: this.screener.id,
                seat_indexes: this.selectedSeats.map((seat) => seat.id),
                ticket_types_discount: ticket_types_discount,
                consumer_uuid: this.consumer_uuid
            }
        },
        async lockSeats(){
            this.bookingLoader = true;
            if(!this.selectedSeats.length){
                return;
            }
            const payload = this._lockSeatsPayload();
            try {
                let response = await this.$store.dispatch("bookings/markSeatsLocked",payload);
                this.onConfirm();
            } catch (error) {
                    this.$store.dispatch("app/showMessage",{
                        message: error.message,
                        color: "error"
                    })
            } finally{
                await this.getSeatsStatus();
                this._removeSelectedSeatsIfLocked();
                this.bookingLoader = false;
            }
        },
        /* Fetch booking if any exists within defined buffer time & booking seats as selected previously */
        async getLockedBooking(){
            this.bookingLoader = true;
            const payload = {
                screener_id:this.screener.id,
                consumer_uuid: this.consumer_uuid
            }
            try{
                let response = await this.$store.dispatch("consumer/getLockedBooking",payload);
                if(!response.booking){
                    return;
                }
                this.lockedSeatsByUser = response.booking.seat_indexes;
                this._setSeatsToSelected(response.booking.seat_indexes,response.booking.ticket_types_discount);
            } catch (error){
                this.$store.dispatch("app/showMessage",{
                    message: error.message,
                    color: "error"
                });
            } finally{
                this.bookingLoader = false;
            }
        },
        /* Removes selected seats if any has been locked by others */
        _removeSelectedSeatsIfLocked(){
            let _this = this;
            this.selectedSeats.forEach((seat)=>{
                /* If seat status is not availble, then remove from selected seats */
                if(_this._seatStatus(seat.id) >= _this.DEFINES.SEATS_STATUS.LOCKED)
                {
                    _this._removeSeatFromSelected(seat.id);
                }
            });
        },
        _setSeatsToSelected(seatIds=[], ticketTypes={}){
            let _this = this;
            seatIds.forEach((seatId)=>{
                var ticketType = this.DEFINES.DEFAULT_SEAT_TICKET_TYPE;
                if(ticketTypes && Object.keys(ticketTypes).length && ticketTypes.hasOwnProperty(seatId)){
                    ticketType = ticketTypes[seatId];
                }
                _this._addSeatToSelected(seatId,ticketType);
            });
        },
        onCancel(){
            this.$emit("onCancel");
            this.reset();
        },
        onConfirm(){
            this.hideSeatChart();
            this.$emit("onConfirm",this.selectedSeats);
        },
    }
}
</script>

<style scoped>
.theater-screen{
    border-top: 4em solid rgba(0,0,0,0.1);
    border-left: 3em solid transparent;
    border-right: 3em solid transparent;
    width: 45%;
    text-align: center;
}
.screen-label{
    position: relative;
    top: -48px;
    color: rgba(0,0,0,0.6);
}
</style>
